export class AddWarrantyServiceModel {
    Id : number;
    Title : string;
    WarrantyServiceTerm : String;    
    Duration:string;
    IsActive: string;
    InstallationPrice :string;
}

export class DurationValueModel {
    Duration : string;
    Price : string;
    InstallationPrice :string;
}